<template>
    <gat-form class="form">   
        <v-layout wrap>                   
            <gat-edit ref="description" size="s" :autofocus=false label="Description" v-model="value.TRA_TEXT" :required=true /> 
            <gat-edit ref= "amount" size="s" label="Amount" v-model="value.TRA_AMOUNT" dataType=number decimals=2 :required=true /> 
            <gat-flex size="m"><category-select v-model="value.TRA_CAT_ID" :errorMsg="value.catErrorMsg"/></gat-flex>                             
        </v-layout>
        
    </gat-form>
</template>

<script>
    import GatEdit from '@/GatComponents/GatEdit.vue';
    import GatForm from '@/GatComponents/GatForm.vue';
    import CategorySelect from '@/components/CategorySelect.vue';
    import GatFlex from '@/GatComponents/GatFlex.vue';
    export default {
        name: 'SplitItem',
        props: ['value'],
        components: {GatEdit,GatForm,CategorySelect,GatFlex},
        data: function() {
            return	{
            }
        },


        created(){
        },

        watch:{
        },

        methods:{
            validate(){
                let result = true;              
                const hasValue = this.value.hasOwnProperty("TRA_AMOUNT") && this.value.TRA_AMOUNT !== 0;
                const hasCategory = this.value.hasOwnProperty("TRA_CAT_ID") && this.value.TRA_CAT_ID > 0;
                const hasDescription = this.value.hasOwnProperty("TRA_TEXT") && this.value.TRA_TEXT.length > 0;
                this.$refs.description.validateValue();
                this.$refs.amount.validateValue();
                if(hasValue){
                    if(!hasCategory){
                        this.value.catErrorMsg = "please select a category";                                                    
                    }else{
                        this.value.catErrorMsg = null;
                    }                
                    result = hasCategory && hasDescription;
                }
                return result;
            }
        },
    }
</script>

<style scoped>
    .form{
        width: 100%;
    }
</style>
